import { Theme, WithStyles, Grid, Paper, Typography, withStyles } from "@material-ui/core";
import Button from '@material-ui/core/Button';
import { SortDirection } from "@material-ui/core/TableCell";
import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router-dom";
import { getApi } from "src/api/ApiProvider";
import googleMaps from "src/api/googleMaps";
import { Opportunity } from "src/api/model";
import AsyncTable, { ColumnDefinition } from "src/components/AsyncTable";
import OpportunityDataComponent from "src/components/visits/opportunityDataComponent";
import { ConfigData } from "src/config";
import { IStore } from "src/store";
import StoreModel, { LoadedSingleResource } from "src/store/StoreModel";
import { VisitActions } from "src/store/visit/visit-actions";
import { mockTheme, WithActions, bindActions } from "src/utils/utils";

const styles = (theme: Theme) => ({
  root: {
    flexGrow: 1,
  },
});

const classesType = styles(mockTheme);

interface OpportunityPageProps extends RouteComponentProps<{ id: string }>,
  WithStyles<keyof typeof classesType>,
  WithActions<VisitActions> {
  config: ConfigData;
  opportunity: LoadedSingleResource<Opportunity>;
  data: any;
}
interface RacePageState {
  notificationData: any[];
  tableNotification: {
    data: any,
    sortBy: string,
    sortDirection: SortDirection
    columnData: ColumnDefinition[]
  }
}

class OpportunityPage extends React.Component<OpportunityPageProps, RacePageState> {
  // trace?: NodeJS.Timer;

  constructor(props: OpportunityPageProps) {
    super(props);
    this.state = {
      notificationData: [],
      tableNotification: {
        data: [],
        sortBy: 'name',
        sortDirection: 'desc',
        columnData: [
          { path: 'message', numeric: false, label: 'Mensaje' },
          { path: 'type', numeric: false, label: 'Tipo' },
          { path: 'notificacionDate', numeric: false, label: 'Fecha' },
        ]
      },
    }
  }

  handleClickNotification(id: number) {
    getApi().history().notificationHistory(id).then(
      (data: any[]) => {
        this.setState({ notificationData: data });
      }).catch(err => {
        console.log('err', err)
      })
  }

  componentDidMount(): void {
    // this.props.actions.fetchWithDriverInfo(this.props.match.params.id, false);
    // this.props.actions.fetchAll();
    // Actualiza la informacion solo del dato obtenido
    // this.trace = setInterval(() => {
    //   this.props.actions.fetchWithDriverInfo(this.props.match.params.id, true);
    // }, 1000 * 10);
  }

  shouldComponentUpdate(nextProps: OpportunityPageProps) {
    if (nextProps.match.params.id === this.props.match.params.id) {
      if (
        StoreModel.isLoaded(nextProps.opportunity) &&
        StoreModel.isLoaded(this.props.opportunity)
      ) {
        return false;
      }
    }
    return true;
  }
  back() {
    this.props.history.goBack();
  }

  renderOpportunity(opport: any) {
    return (
      <>
        <Grid container spacing={16} direction="column">
          <Grid item sm={12} md={6} /*lg={6}*/>
            <Paper elevation={5} style={{ padding: 10 }}>
              <Button color="primary" onClick={() => this.back()}>{"Volver"}</Button>
            </Paper>
          </Grid>
        </Grid>
        <Grid container spacing={16} direction="row">
          <Grid item sm={12} md={6} /*lg={6}*/>
            <Paper elevation={5} style={{ padding: 10 }}>
              <OpportunityDataComponent
                opportunity={opport}
                rutaMapa={() =>
                  (opport.lat && opport.lng && this.props.config) ? googleMaps.buildStaticImage(this.props.config.maps.key, `center=${opport.lat},${opport.lng}&markers=${opport.lat},${opport.lng}`) : ""}
              />
            </Paper>
          </Grid>
          <Grid item sm={12} md={6} /*lg={6}*/>
            <Paper elevation={5} style={{ padding: 10 }}>
              <Typography variant="title">Notificaciones</Typography>
              <AsyncTable
                columnDefinition={this.state.tableNotification.columnData}
                title=''
                showHeader={false}
                data={this.state.notificationData}
                defaultOrder={{
                  name: 'time',
                  direction: 'desc'
                }}
              />
            </Paper>
          </Grid>
        </Grid>
      </>
    );
  }

  render() {
    const { classes } = this.props;
    console.log("render opportunity page", this.props);
    const { data } = this.props.location.state;
    console.log(data)
    if (!data) {
      return <div>Cargando...</div>;
    }
    // if (StoreModel.isError(opportunity)) {
    if (!data) {
      return (
        <Grid container className={classes.root} spacing={16}>
          <Grid item xs={12}>
            <Paper elevation={11} style={{ padding: 40, textAlign: "center" }}>
              <Typography variant="display2" style={{ paddingBottom: 20 }}>
                :(
              </Typography>
              <Typography variant="title">
                El registro de visita que buscas no se ha podido cargar
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      );
    }
    return this.renderOpportunity(data);
  }
}

const mapStateToProps = (state: IStore, ownProps: OpportunityPageProps) => ({
  ...ownProps,
  opportunity: state.visit.all.data[ownProps.match.params.id],
  config: state.config.data,
});

const styled = withStyles(styles as any)(OpportunityPage);
const connected = connect(mapStateToProps, bindActions(VisitActions))(styled)
export default connected as React.ComponentClass<Partial<OpportunityPageProps>>;


// WEBPACK FOOTER //
// ./src/pages/opportunityPage.tsx